// The site's address for links people share (the area card's and area page's Dela, the listing popup's copy
// and share buttons, the place card, the comparison bar): the page's own origin, except on a dev or LAN host,
// where a copied link would reach no one and no chat app could show a preview, so the live site's. That's the
// Pages project's own address while the custom domain (xn--omrdeskollen-vcb.nu) isn't attached to it; switch it
// back here once the domain answers.
export const PUBLIC_SITE_ORIGIN = 'https://omradeskollen5.pages.dev';

const LOCAL_HOST = /^(localhost|127\.|0\.0\.0\.0|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|\[::1\]$)|\.local$/i;

export const publicOrigin = () => {
    if (typeof window === 'undefined' || !window.location) return PUBLIC_SITE_ORIGIN;
    const { hostname, origin } = window.location;
    return LOCAL_HOST.test(hostname || '') ? PUBLIC_SITE_ORIGIN : origin;
};
